import Interface from "./components/Interface";

function App() {
	return (
		<Interface />
	);
}

export default App;